import React, { useEffect, useRef } from 'react'

const AgoraVideoPlayer = ({ videoTrack, ...other }) => {
  const vidDiv = useRef(null)
  useEffect(() => {
    if (vidDiv.current !== null) videoTrack.play(vidDiv.current)
    return () => {
      videoTrack.stop()
    }
  }, [videoTrack])

  return <div {...other} ref={vidDiv} />
}

export default AgoraVideoPlayer
